import React from 'react';

export const VisaIcon: React.FC = () => (
  <svg
    width="36"
    height="26"
    viewBox="0 0 36 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_10288_554)">
      <path
        d="M1 6C1 2.68629 3.68629 0 7 0H29C32.3137 0 35 2.68629 35 6V18C35 21.3137 32.3137 24 29 24H7C3.68629 24 1 21.3137 1 18V6Z"
        fill="white"
      />
      <path
        d="M7 0.5H29C32.0376 0.5 34.5 2.96243 34.5 6V18C34.5 21.0376 32.0376 23.5 29 23.5H7C3.96243 23.5 1.5 21.0376 1.5 18V6C1.5 2.96243 3.96243 0.5 7 0.5Z"
        stroke="#E2E2E2"
      />
    </g>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.7501 15.8582H9.69031L8.14576 9.79235C8.07245 9.51332 7.91679 9.26664 7.68782 9.15038C7.11639 8.85821 6.48672 8.62568 5.7998 8.50841V8.27487H9.11789C9.57583 8.27487 9.91929 8.62568 9.97653 9.0331L10.7779 13.4086L12.8367 8.27487H14.8392L11.7501 15.8582ZM15.984 15.8582H14.0388L15.6406 8.27487H17.5858L15.984 15.8582ZM20.1025 10.3757C20.1597 9.96725 20.5032 9.73372 20.9039 9.73372C21.5336 9.67508 22.2195 9.79235 22.7919 10.0835L23.1354 8.45079C22.5629 8.21725 21.9333 8.09998 21.3619 8.09998C19.4738 8.09998 18.1 9.15038 18.1 10.6082C18.1 11.7173 19.0731 12.2996 19.7601 12.6504C20.5032 13.0002 20.7894 13.2337 20.7322 13.5835C20.7322 14.1082 20.1597 14.3418 19.5883 14.3418C18.9014 14.3418 18.2145 14.1669 17.5858 13.8747L17.2424 15.5084C17.9293 15.7996 18.6724 15.9169 19.3594 15.9169C21.4763 15.9745 22.7919 14.9251 22.7919 13.35C22.7919 11.3664 20.1025 11.2502 20.1025 10.3757ZM29.5998 15.8582L28.0553 8.27487H26.3962C26.0528 8.27487 25.7093 8.50841 25.5948 8.85821L22.7347 15.8582H24.7372L25.1369 14.7502H27.5973L27.8263 15.8582H29.5998ZM26.6824 10.3171L27.2539 13.1751H25.6521L26.6824 10.3171Z"
      fill="#172B85"
    />
    <defs>
      <filter
        id="filter0_d_10288_554"
        x="0"
        y="0"
        width="36"
        height="26"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="0.5" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0784314 0 0 0 0 0.0784314 0 0 0 0 0.0784314 0 0 0 0.05 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_10288_554"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_10288_554"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export const MastercardIcon: React.FC = () => (
  <svg
    width="36"
    height="26"
    viewBox="0 0 36 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_10288_563)">
      <path
        d="M1 6C1 2.68629 3.68629 0 7 0H29C32.3137 0 35 2.68629 35 6V18C35 21.3137 32.3137 24 29 24H7C3.68629 24 1 21.3137 1 18V6Z"
        fill="white"
      />
      <path
        d="M7 0.5H29C32.0376 0.5 34.5 2.96243 34.5 6V18C34.5 21.0376 32.0376 23.5 29 23.5H7C3.96243 23.5 1.5 21.0376 1.5 18V6C1.5 2.96243 3.96243 0.5 7 0.5Z"
        stroke="#E2E2E2"
      />
    </g>
    <path
      d="M22.5771 5.02997C26.322 5.02997 29.3584 8.02986 29.3584 11.7302C29.3583 15.4304 26.322 18.4304 22.5771 18.4304C20.8982 18.4303 19.3629 17.8256 18.1787 16.8268C16.9945 17.8254 15.4591 18.4304 13.7803 18.4304C10.0357 18.4301 7.00011 15.4302 7 11.7302C7 8.02999 10.0356 5.03019 13.7803 5.02997C15.459 5.02997 16.9945 5.63405 18.1787 6.63251C19.3629 5.63391 20.8983 5.03 22.5771 5.02997Z"
      fill="#ED0006"
    />
    <path
      d="M22.5776 5.02997C26.3224 5.03005 29.3579 8.02991 29.3579 11.7302C29.3578 15.4303 26.3224 18.4303 22.5776 18.4304C20.8987 18.4304 19.3634 17.8255 18.1792 16.8268C19.6364 15.598 20.562 13.7714 20.562 11.7302C20.562 9.68867 19.6366 7.8614 18.1792 6.63251C19.3634 5.63397 20.8988 5.02997 22.5776 5.02997Z"
      fill="#F9A000"
    />
    <path
      d="M18.1782 6.63251C19.6358 7.86141 20.561 9.68853 20.561 11.7302C20.561 13.7716 19.6356 15.598 18.1782 16.8268C16.7213 15.598 15.7964 13.7713 15.7964 11.7302C15.7964 9.68882 16.721 7.8614 18.1782 6.63251Z"
      fill="#FF5E00"
    />
    <defs>
      <filter
        id="filter0_d_10288_563"
        x="0"
        y="0"
        width="36"
        height="26"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="0.5" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0784314 0 0 0 0 0.0784314 0 0 0 0 0.0784314 0 0 0 0.05 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_10288_563"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_10288_563"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export const MaestroIcon: React.FC = () => (
  <svg
    width="36"
    height="26"
    viewBox="0 0 36 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_10288_576)">
      <path
        d="M1 6C1 2.68629 3.68629 0 7 0H29C32.3137 0 35 2.68629 35 6V18C35 21.3137 32.3137 24 29 24H7C3.68629 24 1 21.3137 1 18V6Z"
        fill="white"
      />
      <path
        d="M7 0.5H29C32.0376 0.5 34.5 2.96243 34.5 6V18C34.5 21.0376 32.0376 23.5 29 23.5H7C3.96243 23.5 1.5 21.0376 1.5 18V6C1.5 2.96243 3.96243 0.5 7 0.5Z"
        stroke="#E2E2E2"
      />
    </g>
    <path
      d="M13.6289 5C17.2898 5.00006 20.2578 8.0026 20.2578 11.7061C20.2577 15.4094 17.2898 18.4111 13.6289 18.4111C9.96802 18.4111 7.00016 15.4094 7 11.7061C7 8.00257 9.96792 5 13.6289 5Z"
      fill="#ED0006"
    />
    <path
      d="M22.2285 5C25.8895 5.00006 28.8574 8.0026 28.8574 11.7061C28.8573 15.4094 25.8894 18.4111 22.2285 18.4111C18.5676 18.4111 15.5998 15.4094 15.5996 11.7061C15.5996 8.00257 18.5675 5 22.2285 5Z"
      fill="#0099DF"
    />
    <path
      d="M17.9287 6.60388C19.3533 7.83377 20.2577 9.66236 20.2578 11.7054C20.2578 13.7485 19.3532 15.5771 17.9287 16.807C16.5041 15.5771 15.5996 13.7486 15.5996 11.7054C15.5997 9.66231 16.504 7.83377 17.9287 6.60388Z"
      fill="#6C6BBD"
    />
    <defs>
      <filter
        id="filter0_d_10288_576"
        x="0"
        y="0"
        width="36"
        height="26"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="0.5" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0784314 0 0 0 0 0.0784314 0 0 0 0 0.0784314 0 0 0 0.05 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_10288_576"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_10288_576"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export const AmexIcon: React.FC = () => (
  <svg
    width="36"
    height="26"
    viewBox="0 0 36 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_10288_587)">
      <path
        d="M1 6C1 2.68629 3.68629 0 7 0H29C32.3137 0 35 2.68629 35 6V18C35 21.3137 32.3137 24 29 24H7C3.68629 24 1 21.3137 1 18V6Z"
        fill="#1F72CD"
      />
    </g>
    <path
      d="M24.5146 6.90332V4H28.9844L29.7607 6.1875L30.541 4H34.0059V4.94238H31.2422L29.7666 9.04102L28.2998 4.94238H25.4893V11.5225H27.2666V6.91602L28.958 11.5225H30.5371L32.2295 6.90723V11.5225H34.0059V13.8457L32.1992 15.752L34.0059 17.6738V20H31.1699L29.709 18.3848L28.2412 20H18.8887V12.4736H15.8701L19.6143 4H23.2256L24.5146 6.90332ZM19.8877 19.0576H25.4902V17.5352H21.6826V16.5098H25.3965V15.0254H21.6826V14H25.4902V12.4775H19.8877V19.0576ZM28.5918 15.7676L25.4902 19.0576H27.7842L29.7207 16.9336L31.6475 19.0576H34.0059L30.8857 15.749L34.0059 12.4775H31.6846L29.7578 14.583L27.8496 12.4775H25.4902L28.5918 15.7676ZM17.3672 11.5225H19.3418L19.8867 10.207H22.9141L23.4688 11.5225H25.4893L22.585 4.94238H20.2725L17.3672 11.5225ZM22.2939 8.73047H20.5078L21.4004 6.57812L22.2939 8.73047Z"
      fill="white"
    />
    <g filter="url(#filter1_d_10288_587)">
      <path
        d="M7 0.5H29C32.0376 0.5 34.5 2.96243 34.5 6V18C34.5 21.0376 32.0376 23.5 29 23.5H7C3.96243 23.5 1.5 21.0376 1.5 18V6C1.5 2.96243 3.96243 0.5 7 0.5Z"
        stroke="#E2E2E2"
        shapeRendering="crispEdges"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_10288_587"
        x="0"
        y="0"
        width="36"
        height="26"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="0.5" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0784314 0 0 0 0 0.0784314 0 0 0 0 0.0784314 0 0 0 0.05 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_10288_587"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_10288_587"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_d_10288_587"
        x="0"
        y="0"
        width="36"
        height="26"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="0.5" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0784314 0 0 0 0 0.0784314 0 0 0 0 0.0784314 0 0 0 0.05 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_10288_587"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_10288_587"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export const CbIcon: React.FC = () => (
  <svg
    width="36"
    height="26"
    viewBox="0 0 36 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_10288_596)">
      <path
        d="M1 6C1 2.68629 3.68629 0 7 0H29C32.3137 0 35 2.68629 35 6V18C35 21.3137 32.3137 24 29 24H7C3.68629 24 1 21.3137 1 18V6Z"
        fill="black"
      />
      <path d="M1 6C1 2.68629 3.68629 0 7 0H29C32.3137 0 35 2.68629 35 6V18C35 21.3137 32.3137 24 29 24H7C3.68629 24 1 21.3137 1 18V6Z" />
      <path
        d="M7 0.5H29C32.0376 0.5 34.5 2.96243 34.5 6V18C34.5 21.0376 32.0376 23.5 29 23.5H7C3.96243 23.5 1.5 21.0376 1.5 18V6C1.5 2.96243 3.96243 0.5 7 0.5Z"
        stroke="#E2E2E2"
      />
    </g>
    <path
      d="M31.1198 8.33312C31.1198 7.96031 31.0452 7.5875 30.8961 7.2147C30.747 6.84189 30.5233 6.54364 30.2996 6.31996C30.0014 6.02171 29.7031 5.79803 29.3303 5.72346C28.9575 5.57434 28.5102 5.57434 27.9137 5.57434H19.7119V8.33312V11.0919H27.8391C28.4356 11.0919 28.9575 11.0173 29.2558 10.9428C29.6286 10.7937 29.9268 10.6445 30.2251 10.3463C30.5233 10.048 30.6724 9.74979 30.8216 9.45154C31.0452 9.07874 31.1198 8.70593 31.1198 8.33312Z"
      fill="white"
    />
    <path
      d="M31.1198 15.1182C31.1198 14.7454 31.0452 14.3726 30.8961 13.9998C30.747 13.627 30.5233 13.3287 30.2996 13.1051C30.0014 12.8068 29.7031 12.5831 29.3303 12.5086C28.9575 12.3594 28.5102 12.3594 27.9137 12.3594H19.7119V15.1182V17.877H27.8391C28.4356 17.877 28.9575 17.8024 29.2558 17.7279C29.6286 17.5787 29.9268 17.4296 30.2251 17.1314C30.5233 16.8331 30.6724 16.5349 30.8216 16.2366C31.0452 15.8638 31.1198 15.491 31.1198 15.1182Z"
      fill="white"
    />
    <path
      d="M18.5933 11.0919C18.2951 7.51292 15.76 5.12695 11.7337 5.12695C7.48367 5.12695 4.87402 7.73661 4.87402 11.6884C4.87402 15.7893 7.6328 18.2498 11.7337 18.2498C15.76 18.2498 18.2951 15.9384 18.5933 12.2849H11.6591V11.0173H18.5933V11.0919Z"
      fill="white"
    />
    <defs>
      <filter
        id="filter0_d_10288_596"
        x="0"
        y="0"
        width="36"
        height="26"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="0.5" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0784314 0 0 0 0 0.0784314 0 0 0 0 0.0784314 0 0 0 0.05 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_10288_596"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_10288_596"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export const ApplePayIcon: React.FC = () => (
  <svg
    width="36"
    height="26"
    viewBox="0 0 36 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_10288_610)">
      <path
        d="M1 6C1 2.68629 3.68629 0 7 0H29C32.3137 0 35 2.68629 35 6V18C35 21.3137 32.3137 24 29 24H7C3.68629 24 1 21.3137 1 18V6Z"
        fill="white"
      />
      <path
        d="M7 0.5H29C32.0376 0.5 34.5 2.96243 34.5 6V18C34.5 21.0376 32.0376 23.5 29 23.5H7C3.96243 23.5 1.5 21.0376 1.5 18V6C1.5 2.96243 3.96243 0.5 7 0.5Z"
        stroke="#E2E2E2"
      />
    </g>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.4492 8.34316C10.1638 8.69506 9.70721 8.97261 9.2506 8.93296C9.19353 8.45715 9.41707 7.95161 9.67867 7.63936C9.96406 7.27755 10.4635 7.01983 10.8678 7C10.9153 7.49563 10.7298 7.98135 10.4492 8.34316ZM10.863 9.02712C10.4607 9.003 10.0937 9.15319 9.79718 9.2745C9.60639 9.35256 9.44483 9.41867 9.32191 9.41867C9.18397 9.41867 9.01574 9.34903 8.82685 9.27084L8.82685 9.27084C8.57935 9.16838 8.29638 9.05124 7.99964 9.05686C7.31948 9.06677 6.68688 9.46823 6.33967 10.1076C5.62621 11.3863 6.15417 13.2796 6.84384 14.3205C7.18155 14.8359 7.58584 15.4009 8.11855 15.3811C8.35291 15.3719 8.5215 15.2973 8.69597 15.2202C8.89683 15.1314 9.10549 15.0391 9.43131 15.0391C9.74582 15.0391 9.94536 15.129 10.1369 15.2152C10.319 15.2973 10.4939 15.376 10.7536 15.3712C11.3053 15.3613 11.6525 14.8557 11.9902 14.3403C12.3547 13.7871 12.5148 13.2471 12.5391 13.1652L12.542 13.1557C12.5414 13.1551 12.5369 13.153 12.5289 13.1492C12.4071 13.0911 11.476 12.6469 11.467 11.4557C11.4581 10.4559 12.2056 9.94935 12.3233 9.86961L12.3233 9.8696C12.3304 9.86476 12.3353 9.86149 12.3374 9.85978C11.8618 9.12625 11.1198 9.04695 10.863 9.02712ZM14.6824 15.3167V7.5898H17.4649C18.9013 7.5898 19.9049 8.62071 19.9049 10.1274C19.9049 11.6341 18.8822 12.675 17.4268 12.675H15.8334V15.3167H14.6824ZM15.8333 8.60088H17.1603C18.1592 8.60088 18.7299 9.15599 18.7299 10.1324C18.7299 11.1088 18.1592 11.6688 17.1556 11.6688H15.8333V8.60088ZM23.7053 14.3898C23.4009 14.9945 22.7302 15.3761 22.0072 15.3761C20.9371 15.3761 20.1903 14.712 20.1903 13.7108C20.1903 12.7196 20.9133 12.1496 22.2498 12.0653L23.6862 11.9761V11.5499C23.6862 10.9204 23.2915 10.5784 22.5875 10.5784C22.0072 10.5784 21.5839 10.8907 21.4983 11.3665H20.4614C20.4947 10.3653 21.3984 9.63675 22.6208 9.63675C23.9383 9.63675 24.7945 10.3554 24.7945 11.4706V15.3167H23.729V14.3898H23.7053ZM22.3163 14.4592C21.7027 14.4592 21.3127 14.1519 21.3127 13.6811C21.3127 13.1954 21.6885 12.9129 22.4067 12.8683L23.6861 12.784V13.2202C23.6861 13.9438 23.0964 14.4592 22.3163 14.4592ZM28.3284 15.619C27.867 16.9721 27.3391 17.4181 26.2166 17.4181C26.131 17.4181 25.8456 17.4082 25.779 17.3884V16.4616C25.8503 16.4715 26.0263 16.4814 26.1167 16.4814C26.6256 16.4814 26.911 16.2584 27.087 15.6785L27.1916 15.3365L25.2415 9.7111H26.4449L27.8004 14.2759H27.8242L29.1798 9.7111H30.3499L28.3284 15.619Z"
      fill="black"
    />
    <defs>
      <filter
        id="filter0_d_10288_610"
        x="0"
        y="0"
        width="36"
        height="26"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="0.5" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0784314 0 0 0 0 0.0784314 0 0 0 0 0.0784314 0 0 0 0.05 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_10288_610"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_10288_610"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export const GooglePayIcon: React.FC = () => (
  <svg
    width="36"
    height="26"
    viewBox="0 0 36 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_10288_628)">
      <path
        d="M1 6C1 2.68629 3.68629 0 7 0H29C32.3137 0 35 2.68629 35 6V18C35 21.3137 32.3137 24 29 24H7C3.68629 24 1 21.3137 1 18V6Z"
        fill="white"
      />
      <path
        d="M7 0.5H29C32.0376 0.5 34.5 2.96243 34.5 6V18C34.5 21.0376 32.0376 23.5 29 23.5H7C3.96243 23.5 1.5 21.0376 1.5 18V6C1.5 2.96243 3.96243 0.5 7 0.5Z"
        stroke="#E2E2E2"
      />
    </g>
    <path
      d="M27.7114 14.1297H27.729L29.146 10.5711H30.1431L27.0796 17.7059H26.1343L27.2729 15.2098L25.2632 10.5711H26.2593L27.7114 14.1297ZM22.9175 10.41C23.5949 10.41 24.1301 10.5949 24.5229 10.9588C24.9156 11.3226 25.1088 11.8306 25.1089 12.4715V15.5281H24.2329V14.8406H24.1929C23.8114 15.4067 23.3101 15.6892 22.6782 15.6893C22.143 15.6893 21.6873 15.5274 21.3286 15.2039C20.9757 14.9035 20.7762 14.4589 20.7876 13.991C20.7877 13.477 20.9813 13.0725 21.3628 12.7664C21.7442 12.4604 22.2565 12.3104 22.894 12.3104C23.4405 12.3104 23.8848 12.4139 24.2378 12.6102V12.3973C24.2378 12.0797 24.1017 11.779 23.8628 11.5711C23.618 11.3516 23.3045 11.2303 22.98 11.2303C22.4675 11.2303 22.0632 11.4495 21.7671 11.8885L20.9585 11.3738C21.3912 10.7329 22.0465 10.41 22.9175 10.41ZM18.5728 8.28399C19.1592 8.27251 19.7284 8.498 20.144 8.91387C20.9751 9.69951 21.0265 11.0218 20.2466 11.8709L20.144 11.9754C19.7171 12.3854 19.1932 12.5935 18.5728 12.5936H17.0581V15.5281H16.1411V8.28399H18.5728ZM23.0366 13.0613C22.6666 13.0614 22.3535 13.1538 22.103 13.3328C21.8582 13.5119 21.7329 13.7371 21.7329 14.0086C21.7329 14.2512 21.8468 14.4764 22.0347 14.615C22.2397 14.7768 22.4903 14.864 22.7466 14.8582C23.1337 14.8582 23.5035 14.7017 23.7769 14.4246C24.0787 14.1358 24.2329 13.7949 24.2329 13.4022C23.9482 13.1711 23.5492 13.0556 23.0366 13.0613ZM17.0581 11.7039H18.5952C18.9369 11.7155 19.268 11.5763 19.5015 11.3279C19.9796 10.8253 19.9676 10.0162 19.4722 9.53106C19.2387 9.30026 18.9253 9.17364 18.5952 9.17364H17.0581V11.7039Z"
      fill="#3C4043"
    />
    <path
      d="M13.8926 11.9578C13.8926 11.6747 13.8698 11.3917 13.8243 11.1144H9.95801V12.7146H12.173C12.0819 13.2287 11.7858 13.6909 11.3531 13.9797V15.0195H12.6741C13.4485 14.2974 13.8926 13.2287 13.8926 11.9578Z"
      fill="#4285F4"
    />
    <path
      d="M9.95817 16.0247C11.0628 16.0247 11.9967 15.655 12.6743 15.0196L11.3532 13.9797C10.9831 14.2339 10.5105 14.3783 9.95817 14.3783C8.88768 14.3783 7.98232 13.6447 7.65776 12.6626H6.29688V13.7371C6.99155 15.1409 8.40938 16.0247 9.95817 16.0247Z"
      fill="#34A853"
    />
    <path
      d="M7.65797 12.6626C7.48712 12.1485 7.48712 11.5882 7.65797 11.0682V9.99951H6.29687C5.71029 11.1722 5.71029 12.5587 6.29687 13.7314L7.65797 12.6626Z"
      fill="#FBBC04"
    />
    <path
      d="M9.95817 9.35247C10.5447 9.34092 11.1084 9.56621 11.5297 9.97637L12.7027 8.78634C11.9568 8.08156 10.9774 7.69451 9.95817 7.70606C8.40938 7.70606 6.99155 8.5957 6.29688 9.99948L7.65776 11.074C7.98232 10.0861 8.88768 9.35247 9.95817 9.35247Z"
      fill="#EA4335"
    />
    <defs>
      <filter
        id="filter0_d_10288_628"
        x="0"
        y="0"
        width="36"
        height="26"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="0.5" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0784314 0 0 0 0 0.0784314 0 0 0 0 0.0784314 0 0 0 0.05 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_10288_628"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_10288_628"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export const KlarnaIcon: React.FC = () => (
  <svg
    width="36"
    height="26"
    viewBox="0 0 36 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_10288_654)">
      <path
        d="M1 6C1 2.68629 3.68629 0 7 0H29C32.3137 0 35 2.68629 35 6V18C35 21.3137 32.3137 24 29 24H7C3.68629 24 1 21.3137 1 18V6Z"
        fill="#FEB4C7"
      />
      <path
        d="M7 0.5H29C32.0376 0.5 34.5 2.96243 34.5 6V18C34.5 21.0376 32.0376 23.5 29 23.5H7C3.96243 23.5 1.5 21.0376 1.5 18V6C1.5 2.96243 3.96243 0.5 7 0.5Z"
        stroke="#E2E2E2"
      />
    </g>
    <path
      d="M14.6406 10.8447C15.0993 10.8448 15.5245 10.9947 15.877 11.249V10.9668H17.125V15.3779H15.877V15.0957C15.5245 15.3501 15.0994 15.4999 14.6406 15.5C13.4261 15.5 12.4416 14.4581 12.4414 13.1729C12.4414 11.8874 13.426 10.8447 14.6406 10.8447ZM27.8057 10.8447C28.2644 10.8448 28.6896 10.9947 29.042 11.249V10.9668H30.29V15.3779H29.042V15.0957C28.6896 15.35 28.2645 15.4999 27.8057 15.5C26.5912 15.5 25.6066 14.4581 25.6064 13.1729C25.6064 11.8874 26.591 10.8447 27.8057 10.8447ZM31.6152 13.8135C32.0475 13.8137 32.3984 14.185 32.3984 14.6426C32.3982 15.0999 32.0474 15.4705 31.6152 15.4707C31.1829 15.4707 30.8323 15.1 30.832 14.6426C30.832 14.1848 31.1828 13.8135 31.6152 13.8135ZM6.26953 9V15.3799H4.88574V9H6.26953ZM9.72363 9C9.72363 10.3811 9.21478 11.6661 8.30859 12.6211L10.2197 15.3799H8.51172L6.43457 12.3818L6.9707 11.957C7.85995 11.2521 8.37012 10.174 8.37012 9H9.72363ZM11.9297 15.3779H10.623V9.00098H11.9297V15.3779ZM19.0557 11.541C19.3058 11.1967 19.7718 10.9669 20.2783 10.9668V12.251C20.2734 12.2509 20.2686 12.25 20.2637 12.25C19.77 12.2501 19.0587 12.6237 19.0586 13.3184V15.3779H17.7783V10.9668H19.0557V11.541ZM23.3887 10.8486C24.3939 10.8487 25.165 11.5468 25.165 12.5732V15.3779H23.9189V13.0508C23.9189 12.4074 23.6031 12.0605 23.0547 12.0605C22.5431 12.0606 22.1183 12.3891 22.1182 13.0596V15.3779H20.8604V10.9668H22.1025V11.4639C22.418 11.012 22.8902 10.8486 23.3887 10.8486ZM14.7432 12.0381C14.1187 12.0381 13.6123 12.5461 13.6123 13.1729C13.6125 13.7995 14.1188 14.3076 14.7432 14.3076C15.3674 14.3074 15.8729 13.7993 15.873 13.1729C15.873 12.5462 15.3675 12.0383 14.7432 12.0381ZM27.9082 12.0381C27.2837 12.0381 26.7773 12.5461 26.7773 13.1729C26.7775 13.7995 27.2838 14.3076 27.9082 14.3076C28.5324 14.3074 29.0379 13.7993 29.0381 13.1729C29.0381 12.5462 28.5325 12.0383 27.9082 12.0381Z"
      fill="#17120F"
    />
    <defs>
      <filter
        id="filter0_d_10288_654"
        x="0"
        y="0"
        width="36"
        height="26"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="0.5" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0784314 0 0 0 0 0.0784314 0 0 0 0 0.0784314 0 0 0 0.05 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_10288_654"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_10288_654"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export const BRAND_ICON_MAP: Record<string, React.FC> = {
  visa: VisaIcon,
  mastercard: MastercardIcon,
  maestro: MaestroIcon,
  cb: CbIcon,
  apple_pay: ApplePayIcon,
  google_pay: GooglePayIcon,
  klarna: KlarnaIcon,
  amex: AmexIcon,
};
